import ApiService from '@/data/services/ApiService'
import { ITestResult, ITestResultCreate } from '@/data/models/TestResult'
import { AxiosResponse, AxiosRequestConfig } from 'axios'
import { IPaginatedServiceResponse, IServiceResponse } from '@/data/models/ServiceResponse'
import { IPaginationQueryParams, ITeamPaged } from '@/data/models'

export class DiagnosticResultApiService extends ApiService {
  /**
   * Given data, creates new entry in database
   *
   * @param testResultFormData
   */
  static async create(testResultFormData: ITestResultCreate): Promise<IServiceResponse<ITestResult>> {
    return this.axios.post('diagnostic-results', testResultFormData)
      .then((response: AxiosResponse<IServiceResponse<ITestResult>>) => response.data)
  }

  static async update(testResultId: number, testResultFormData: ITestResultCreate): Promise<IServiceResponse<ITestResult>> {
    return this.axios.patch(`diagnostic-results/${testResultId}`, testResultFormData)
      .then((response: AxiosResponse<IServiceResponse<ITestResult>>) => response.data)
  }

  static async get(params: IPaginationQueryParams): Promise<IPaginatedServiceResponse<ITestResult>> {
    return this.axios.get('diagnostic-results', { params: params })
      .then((response: AxiosResponse<IPaginatedServiceResponse<ITestResult>>) => response.data)
  }
}
